import React, { useState } from "react";
import {
  Layout,
  Input,
  Button,
  Card,
  Typography,
  Form,
  message,
  Tabs,
  Spin,
  Upload,
  Breadcrumb,
  Popconfirm,
  Table,
  Badge,
  Menu,
  Dropdown
} from "antd";

import { useNavigator } from "../../utilities/navigation";
import { useQuery, useQueryClient, useMutation } from 'react-query'
import { utilities } from "../../utilities/utlities";
import "./styles.css";
import AddContactDialog from './AddContactDoalog'
import { AddUser } from './api'
import { addUser } from "../../configurations/addUser";
import { useEffect } from "react";
import {EllipsisOutlined} from '@ant-design/icons'
import csv from 'csvtojson'
import { Link } from "react-router-dom";

export default function ManageContact() {
  const [navigator] = useNavigator()
  const { Content } = Layout
  const { TabPane } = Tabs;
  const loginUser = utilities.loggedUser();
  const client = useQueryClient()
  const [loadinForAdmin, setloadinForAdmin] = useState(false)
  const [visible, setVisible] = useState(false)
  const [companyId, setCompanyId] = useState('')
  const [contactDetail, setContactDetail] = useState({})
  const [dataTable, setDataTable] = useState([])
  const { Title, Text } = Typography
  const [mode,setMode] = useState('save')
  const [templateFile,setTemplateFile] = useState('')
  const approveUser = (value) => {
    setVisible(value)

  }
  const columns = [
    {
      title: 'ID',
      dataIndex: 'number',
      key: 'number',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Association',
      dataIndex: 'association',
      key: 'association',
    },
    {
      title: 'Phone No',
      dataIndex: 'phoneno',
      key: 'phoneno',
    },
    {
      title: 'Actions',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => (
        <Dropdown overlay={<Menu>
          <Menu.Item onClick={()=>{
            inviteContact(record?.email)
            // alert(record?.email)
          }}>Invite</Menu.Item>
          <Menu.Item onClick={()=>{
            editContact(record)
          }}>Edit</Menu.Item>
          <Menu.Item onClick={()=>{
            console.log(record)
            deleteContact.mutateAsync({
              contact_id:record?.id,
              companyId:companyId,
              token: loginUser?.jwtToken
            })
          }}>Delete</Menu.Item>
        </Menu>} placement="bottomCenter">
        <a><EllipsisOutlined/></a>
      </Dropdown>
      )
    }
  ];

  useEffect(() => {
    refetch()
  }, [])
  const deleteContact = useMutation(data=>{
    return AddUser.deleteContact(data)
  },{
    onSuccess:(data)=>{
      console.log(data)
      if(data?.data != undefined){
      if(data?.data?.success == true){
        message.success(data?.data?.message,3)
        const tableData = data?.data?.data?.contacts?.map((item, index) => {
          return {
            number: index,
            name: item?.firstName!= undefined ? item?.firstName : ' ' +' '+ item?.lastName!= undefined ? item?.lastName:'',
            email: item?.email,
            association: item?.description,
            phoneno: item?.phoneNumber,
            id:item?._id
          }
        })
        setDataTable(tableData)

      }
      else{
        message.error("Something Went Wrong !")
      }
    }
    else{
      message.error("Something Went Wrong")
    }

    },
    onError:(errror)=>{

    }
  })
  const onImportUser = (data)=>{
    console.log(data)
    const userdata = data?.map(item=>{
      return {
        firstName:item?.['First Name'] + ' ' + item?.['Last Name'],
        email:item?.['Email'],
        description:item?.['Comment'],
        phoneNumber:item?.['Phone No']

      }
    })
    importUser.mutateAsync({
      contactdetail: userdata,
      companyId: companyId,
      token: loginUser?.jwtToken
    })
    console.log(userdata)
  }
  const getUser = (data) => {
    setCompanyId(data?.data?.company?._id)
    companyFetch()
  }
  const { isLoading, refetch, data: profileData } = useQuery('profileUser', async () => {
    return AddUser.fetchUserData(loginUser?.jwtToken)
  }, {
    enabled: false,
    onSuccess: getUser
  })

  const { isLoading: companyLoader, refetch: companyFetch } = useQuery('companyContact', async () => {
    console.log(client.getQueryData('profileUser')?.data)
    return AddUser.getUserContact(loginUser?.jwtToken, client.getQueryData('profileUser')?.data?.company?._id)
  }, {
    enabled: false,
    onSuccess: (data) => {
      addToList(data?.data)
    }
  })
  const mutation = useMutation(async (data) => {
    return AddUser.addUser(data)
  }, {
    enabled: false,
    onSuccess: (data) => {
      if(data?.data != undefined){
      message.success("New Contact added successfully", 3)
      console.log(data?.data)
      addToList(data?.data)
      approveUser(false)
      setContactDetail({})
      }
      else{
        message.error("Something went Wrong !",3)
      }

    },
    onError: (err) => {
      message.error('Something went wrong', 3)
    }

  })
  const onCancel = ()=>{
    setContactDetail({})
  }
  const importUser = useMutation(async (data) => {
    return AddUser.importUser(data)
  }, {
    enabled: false,
    onSuccess: (data) => {
      console.log(data)
      if(data?.data == undefined){
        message.error("Something Went Wrong", 3)
      }
      else{
      message.success("User Contact import successfully", 3)
      addToList(data?.data)
      approveUser(false)
      // setContactDetail({})
      }

    },
    onError: (err) => {
      message.error('Something went wrong', 3)
    }

  })
  const editData = useMutation(async (data) => {
    console.log(data)
    return AddUser.EditContact(data)
  }, {
    enabled: false,
    onSuccess: (data) => {
      message.success("Contact Updated successfully", 3)
      console.log(data?.data)
      addToList(data?.data)
      approveUser(false)
      setContactDetail({})
      setMode('save')

    },
    onError: (err) => {
      message.error('Something went wrong', 3)
    }

  })


  const addContact = (key, value) => {
    setContactDetail({
      ...contactDetail,
      [key]: value
    })
  }

  const editContact = (data)=>{
    console.log(data)
    setVisible(true)
    setContactDetail(data)
    setMode('edit')
  }

  const addToList = (data) => {
    const tableData = data?.contacts?.map((item, index) => {
      return {
        number: index,
        name: item?.firstName!= undefined ? item?.firstName : ' ' +' '+ item?.lastName!= undefined ? item?.lastName:'',
        email: item?.email,
        association: item?.description,
        phoneno: item?.phoneNumber,
        id:item?._id
      }
    })
    setTemplateFile(data?.templateFileUrl)
    setDataTable(tableData)
  }


  const onSaveContact = () => {
    if(Object.keys(contactDetail).length>0){
    mutation.mutateAsync({
      contactdetail: contactDetail,
      companyId: companyId,
      token: loginUser?.jwtToken
    })
    console.log(contactDetail)
  }
  else{
    message.warning("Please add Contact detail first")
  }
  }
  const inviteContact  = (email)=>{
    navigator(`/invite?contact_email=${email}`)
}

  const onSaveEditContact = ()=>{
    editData.mutateAsync({
      contactdetail: contactDetail,
      companyId: companyId,
      token: loginUser?.jwtToken

    })
  }
  const readFile = async(evt)=>{
    const input = evt;
      const reader = new FileReader();

      reader.onload = function (e) {
        const text = e.target.result;
         const data =  csvToArray(text)
         data.pop();
         onImportUser(data)
      };

      reader.readAsText(input);
  }

  const  csvToArray =(str, delimiter = ",")=>{
    const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
  const rows = str.slice(str.indexOf("\n") + 1).split("\n");
  const arr = rows.map(function (row) {
    const values = row.split(delimiter);
    const el = headers.reduce(function (object, header, index) {
      object[header] = values[index];
      return object;
    }, {});
    return el;
  });
  return arr;

  }
  return (
    <Layout className="layout">
      <>
        <AddContactDialog
          contactDetail={contactDetail}
          visible={visible}
          approveUser={approveUser}
          addUser={addUser}
          addContact={addContact}
          onSaveContact={onSaveContact}
          editContact = {editContact}
          mutation = {mutation}
          onSaveEditContact = {onSaveEditContact}
          onCancel = {onCancel}
          mode = {mode}
          editData = {editData}
          readFile = {readFile}
          importUser = {importUser}
          templateFile = {templateFile}

        />
        <Content className={`${loadinForAdmin == true ? 'loading-content' : ''}`}>
          {loadinForAdmin == true ?
            <Spin size="large" tip="Please Wait..." />
            :
            <>
              <div className="user-name-title-container">
                <div className="user-name-title">
                  <Title className="username">
                    Manage Users
                  </Title>
                </div>
                <Button type="primary" onClick={() => {
                  approveUser(true)
                }}>Add User</Button>
              </div>
              <div className="site-layout-content profileViewContainer">
                {companyLoader != false || isLoading != false ?
                  <Spin /> :
                  <Table
                    className="userMangeTable"
                    columns={columns}
                    dataSource={dataTable}
                    pagination={false}
                  />
                }
              </div>
            </>
          }
        </Content>
      </>
    </Layout>
  )
}
